import { api } from './client';
import type { Stats } from '../types/models';

export async function getStats(): Promise<Stats> {
  return api.get<Stats>('/api/stats');
}
